import { Button, Flex, Modal, Text } from "@mantine/core";

interface INotCompletedEntriesModal {
  opened: boolean;
  close: () => void;
  notCompletedEntriesNumber: number | undefined;
}

const NotCompletedEntriesModal = ({
  opened,
  close,
  notCompletedEntriesNumber,
}: INotCompletedEntriesModal) => {
  const handleOk = () => {
    close();
  };

  return (
    <Modal
      opened={opened}
      onClose={close}
      title="Not completed entries"
      size="40vw"
      yOffset={"10dvw"}
      zIndex={1001}>
      <Flex w={"100%"} justify={"center"}>
        <Text>
          There are {notCompletedEntriesNumber ?? ""} entry that have not been
          completed, please ensure all entry are completed before marking the
          review as complete!
        </Text>
      </Flex>
      <Flex mt={10} h={"100%"} w={"100%"} justify={"center"} gap={10}>
        <Button onClick={handleOk}>Ok</Button>
      </Flex>
    </Modal>
  );
};

export default NotCompletedEntriesModal;
